import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { Input } from '@/components/ui/input';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { PropertyRule } from '@/hooks/usePropertyRules';
import FormModal from '@/components/v2/molecules/admin/shared/FormModal';
import { useEffect } from 'react';

interface PropertyRuleFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (title: string) => void;
  rule?: PropertyRule | null;
}

const ruleSchema = z.object({
  title: z.string().min(1, 'El título es obligatorio'),
});

type RuleFormData = z.infer<typeof ruleSchema>;

const PropertyRuleFormModal = ({
  isOpen,
  onClose,
  onSave,
  rule,
}: PropertyRuleFormModalProps) => {
  const form = useForm<RuleFormData>({
    resolver: zodResolver(ruleSchema),
    defaultValues: {
      title: '',
    },
  });

  useEffect(() => {
    if (isOpen) {
      if (rule) {
        form.reset({ title: rule.title });
      } else {
        form.reset({ title: '' });
      }
    }
  }, [rule, isOpen, form]);

  const handleSubmit = (data: RuleFormData) => {
    onSave(data.title.trim());
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={rule ? 'Editar Regla' : 'Nueva Regla'}
      form={form}
      onSubmit={handleSubmit}
      submitLabel={rule ? 'Actualizar' : 'Crear'}
      maxWidth="max-w-[500px]"
    >
      <div className="space-y-4">
        <FormField
          control={form.control}
          name="title"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Título *</FormLabel>
              <FormControl>
                <Input
                  placeholder="Ej: Check-in: 3:00 PM"
                  {...field}
                  autoFocus
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </FormModal>
  );
};

export default PropertyRuleFormModal;
